import React, { useState } from 'react'

import { CloseIcon } from './CloseIcon'
import { CloseButtonProps } from 'react-toastify'

export const CloseButton: React.FC<CloseButtonProps> = ({ closeToast }) => {
  const [isIconBold, setIsIconBold] = useState<boolean>(false)

  return (
    <div
      onMouseOver={() => setIsIconBold(true)}
      onMouseOut={() => setIsIconBold(false)}
      onClick={closeToast}
    >
      <CloseIcon isBold={isIconBold} />
    </div>
  )
}
